import { FormEvent, KeyboardEvent, FocusEvent } from 'react';
import { css } from '@emotion/react';
import { Provider } from '@atlaskit/collab-provider';
import { token } from '@atlaskit/tokens';

export const titleArea = css`
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans',
    'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif;
  border: none;
  outline: none;
  font-size: 2em;
  margin: 0 0 21px;
  padding: 0;
  width: 100%;
  resize: none;
  vertical-align: bottom;
  color: ${token('color.text')};

  /* Blend into the page bg colour. This way it's theme agnostic. */
  background: transparent;

  &::placeholder {
    color: ${token('color.text.subtlest', '#6B778C')};
  }

  @media (max-width: 810px) {
    &::placeholder {
      font-size: 1.5rem;
    }
  }

  @media (max-width: 705px) {
    &::placeholder {
      font-size: 1.25rem;
    }
  }
`;

interface TitleInputProps {
  value?: string;
  placeholder?: string;
  onChange?: (e: FormEvent<HTMLTextAreaElement>, provider?: Provider) => void;
  innerRef?: (ref: HTMLTextAreaElement) => void;
  onFocus?: (e: FocusEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: FocusEvent<HTMLTextAreaElement>) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLTextAreaElement>) => void;
  onKeyUp?: (e: KeyboardEvent<HTMLTextAreaElement>) => void;
  provider?: Provider;
}

export const TitleInput = ({
  value,
  placeholder,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  onKeyUp,
  provider
}: TitleInputProps) => {
  const handleTitleResize = (e: FormEvent<HTMLTextAreaElement>) => {
    const elem = e.target as HTMLTextAreaElement;
    elem.style.height = 'inherit';
    elem.style.height = `${elem.scrollHeight}px`;
  };
  const handleUpdate = (e: FormEvent<HTMLTextAreaElement>) => {
    handleTitleResize(e);
    if (onChange) {
      onChange(e, provider);
    }
  };

  return (
    <textarea
      css={titleArea}
      id="editor-title"
      maxLength={255}
      rows={1}
      data-test-id="editor-title"
      placeholder={placeholder ?? 'Give this page a title'}
      value={value}
      onChange={handleUpdate}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
    />
  );
};
